import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import Person from 'front/components/Person/Person.js'
import BaseView from 'front/components/BaseView/BaseView.js'

import './PersonList.css'
import template from './PersonList.jinja'


var PersonList = BaseView.extend({
    el: '.PersonList',

    initialize () {
        this.views = _.map(this.$el.find('.Person'), (el) => {
            return new Person({
                el: $(el)
            })
        })
    }
})

export default PersonList


// WEBPACK FOOTER //
// ./assets/app/front/components/PersonList/PersonList.js